/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Empty_EventsInputs */

const en_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Empty Events`)
};

const fr_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les événements vides`)
};

const de_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Ereignisse entfernen`)
};

const it_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi eventi vuoti`)
};

const ru_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить пустые события`)
};

const es_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar eventos vacíos`)
};

const zh_cn2_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除空事件`)
};

const ja_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空のイベントを削除する`)
};

const hi_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली इवेंट हटाएँ`)
};

const pt_pt2_remove_empty_events = /** @type {(inputs: Remove_Empty_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover eventos vazios`)
};

/**
* | output |
* | --- |
* | "Remove Empty Events" |
*
* @param {Remove_Empty_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_empty_events = /** @type {((inputs?: Remove_Empty_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Empty_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_empty_events(inputs)
	if (locale === "de") return de_remove_empty_events(inputs)
	if (locale === "it") return it_remove_empty_events(inputs)
	if (locale === "ru") return ru_remove_empty_events(inputs)
	if (locale === "es") return es_remove_empty_events(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_empty_events(inputs)
	if (locale === "ja") return ja_remove_empty_events(inputs)
	if (locale === "hi") return hi_remove_empty_events(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_empty_events(inputs)
	return en_remove_empty_events(inputs)
});